export const strPadZeroL = (input: string, length: number): string => {
  const padLength = length - input.length;
  return '0'.repeat(padLength) + input;
};
